(() => {
  "use strict";
  customElements.get("press-component") ||
    customElements.define(
      "press-component",
      class extends HTMLElement {
        constructor() {
          (super(),
            (this.slider = this.querySelector("[data-press-items]")),
            (this.sliderNav = this.querySelector("[data-logo-slider]")),
            (this.activated = !1),
            (this.listening = !1),
            (this.activationObserver = null),
            (this.checkSlidesEvent = () => this.checkSlides()),
            (this.sliderResizeEvent = () => this.resizeSlider()),
            (this.activateEvent = () => this.activate()),
            (this.sectionSelectEvent = (e) => {
              (e.target === this || e.target.contains?.(this)) &&
                this.activate();
            }));
        }
        connectedCallback() {
          if (this.activated)
            return (this.bindGlobalListeners(), void this.resizeSlider());
          window.Shopify?.designMode ||
          (function (e) {
            const t = e.getBoundingClientRect(),
              i = window.innerHeight || document.documentElement.clientHeight;
            return t.top <= i + 800 && t.bottom >= -800;
          })(this)
            ? this.activate()
            : (this.addEventListener("focusin", this.activateEvent, {
                once: !0,
              }),
              this.addEventListener("pointerdown", this.activateEvent, {
                once: !0,
              }),
              document.addEventListener(
                "shopify:section:select",
                this.sectionSelectEvent,
              ),
              "IntersectionObserver" in window
                ? ((this.activationObserver = new IntersectionObserver(
                    (e) => {
                      e.some((e) => e.isIntersecting) && this.activate();
                    },
                    { rootMargin: "800px 0px" },
                  )),
                  this.activationObserver.observe(this))
                : this.activate());
        }
        activate() {
          this.activated ||
            ((this.activated = !0),
            this.activationObserver?.disconnect(),
            (this.activationObserver = null),
            this.removeEventListener("focusin", this.activateEvent),
            this.removeEventListener("pointerdown", this.activateEvent),
            document.removeEventListener(
              "shopify:section:select",
              this.sectionSelectEvent,
            ),
            this.slider &&
              this.sliderNav &&
              (this.resizeSlider(), this.bindGlobalListeners()));
        }
        bindGlobalListeners() {
          this.listening ||
            ((this.listening = !0),
            document.addEventListener(
              "theme:resize:width",
              this.checkSlidesEvent,
            ),
            document.addEventListener(
              "theme:resize:width",
              this.sliderResizeEvent,
            ));
        }
        checkSlides() {
          const e = this.closest("section");
          if (!e) return;
          const t = e.offsetWidth,
            i = this.querySelectorAll("[data-logo-slide]"),
            s = window.theme.Flickity.data(this.sliderNav) || null;
          null !== s &&
            ((s.options.draggable = !1),
            (s.options.wrapAround = !1),
            (s.options.contain = !0),
            this.getSlidesWidth() > t &&
              i.length > 2 &&
              ((s.options.draggable = !0),
              (s.options.wrapAround = !0),
              (s.options.contain = !1)),
            s.resize(),
            s.updateDraggable());
        }
        getSlidesWidth() {
          const e = this.querySelectorAll("[data-logo-slide]");
          let t = 0;
          return (
            e.forEach((e) => {
              t += e.offsetWidth;
            }),
            t
          );
        }
        initSlider() {
          let e = window.theme.Flickity.data(this.slider) || null,
            t = window.theme.Flickity.data(this.sliderNav) || null;
          const i = parseInt(this.dataset.duration),
            s = "true" === this.dataset.autoplay && i;
          ((e = new window.theme.Flickity(this.slider, {
            fade: !0,
            wrapAround: !0,
            adaptiveHeight: !1,
            prevNextButtons: !1,
            pageDots: !1,
            autoPlay: s,
            on: {
              ready: () => {
                requestAnimationFrame(() => {
                  e?.resize();
                });
              },
            },
          })),
            (t = new window.theme.Flickity(this.sliderNav, {
              draggable: !1,
              wrapAround: !1,
              contain: !0,
              imagesLoaded: !0,
              asNavFor: this.slider,
              prevNextButtons: !1,
              adaptiveHeight: !1,
              pageDots: !0,
              on: {
                ready: () => {
                  (this.querySelectorAll("[data-logo-slide]").forEach((t) => {
                    t.addEventListener("keyup", (i) => {
                      if (
                        i.code === window.theme.keyboardKeys.ENTER ||
                        i.code === window.theme.keyboardKeys.NUMPADENTER ||
                        i.code === window.theme.keyboardKeys.SPACE
                      ) {
                        const i = Number(t.getAttribute("data-logo-index"));
                        e.selectCell(i);
                      }
                    });
                  }),
                    requestAnimationFrame(() => {
                      t?.resize();
                    }));
                },
              },
            })),
            window.theme.flickitySmoothScrolling(this.slider),
            window.theme.flickitySmoothScrolling(this.sliderNav),
            t.on("change", (t) => {
              e.selectCell(t);
            }),
            e.on("change", (t) => {
              e.cells.forEach((e, i) => {
                e.element.querySelectorAll("a, button").forEach((e) => {
                  e.setAttribute("tabindex", i === t ? "0" : "-1");
                });
              });
            }));
        }
        resizeSlider() {
          const e = window.theme.Flickity.data(this.slider) || null,
            t = window.theme.Flickity.data(this.sliderNav) || null;
          if (e && t) return (e.resize(), void t.resize());
          (this.initSlider(), setTimeout(() => this.checkSlides(), 300));
        }
        disconnectedCallback() {
          (this.activationObserver?.disconnect(),
            (this.activationObserver = null),
            this.removeEventListener("focusin", this.activateEvent),
            this.removeEventListener("pointerdown", this.activateEvent),
            document.removeEventListener(
              "shopify:section:select",
              this.sectionSelectEvent,
            ),
            document.removeEventListener(
              "theme:resize:width",
              this.checkSlidesEvent,
            ),
            document.removeEventListener(
              "theme:resize:width",
              this.sliderResizeEvent,
            ),
            (this.listening = !1));
        }
      },
    );
})();
